export interface IReferralMember {
  id: string;
  referralTokenId: string;
  memberEmail: string;
  creditsEarned: number;
  status: ReferralMemberEnum;
  referredName: string | null;
  updatedAt: string;
  createdAt: string;
  referralToken: {
    userId: string;
    user: {
      email: string;
      firstname: string;
      lastname: string;
    };
  };
}

export enum ReferralMemberEnum {
  "Completed",
  "InProgress",
}
